module.exports = __webpack_public_path__ + "static/media/grey-star.6c2e3b87.svg";